module.exports = __webpack_public_path__ + "img/audio.07eb4b8d.svg";